import { Center, Flex, Spinner, Text, VStack } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { SessionDataWithPlayerCount } from '../../service/analytics';
import { getGameName } from '../../service/lobby';
import { convertDurationToDisplay } from '../../util/label';

export interface PastSixListItemProps {
    sessionDatas?: SessionDataWithPlayerCount[];
    index: number;
    date: string;
}

export interface PastSixListItemDisplayData {
    totalHours: string;
}

export const PastSixListItem: React.FC<PastSixListItemProps> = ({ sessionDatas, index, date }) => {
    const intl = useIntl();
    const [displayData, setDisplayData] = useState<PastSixListItemDisplayData>();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const loadData = async () => {
            let totalHours = 0;
            sessionDatas?.forEach((x) => {
                totalHours += x.room_destroyed_ms - x.room_created_ms;
            });
            setDisplayData({
                totalHours: convertDurationToDisplay(totalHours, intl),
            });

            setIsLoading(false);
        };

        loadData();
    }, [sessionDatas, index, date]);

    return (
        <>
            {isLoading ? (
                <Center width="100%" height="100%">
                    <Spinner data-cy="loading" />
                </Center>
            ) : (
                <VStack className="past-six-compact-vstack">
                    <Flex className={'divider'} />
                    {displayData && (
                        <Flex className={`past-six-compact`}>
                            <Flex className={'compact-flex-date-container'}>
                                <Text className="header-date-text">{date}</Text>
                            </Flex>
                            <Flex className={'compact-flex-date-container'}>
                                <Text className="header-hours-text">{displayData.totalHours}</Text>
                            </Flex>
                        </Flex>
                    )}
                    {sessionDatas &&
                        sessionDatas.map((sessionData, idx) => (
                            <Flex
                                key={idx}
                                className={`past-six-compact${idx % 2 === 1 ? '' : '-light'}`}
                            >
                                <Flex className={'compact-flex-container'}>
                                    <Text className="name-game-text">
                                        {getGameName(sessionData.license) || sessionData.license}
                                    </Text>
                                </Flex>
                                <Flex className={'compact-flex-container'}>
                                    <Text className="duration-text">
                                        {convertDurationToDisplay(
                                            sessionData.room_destroyed_ms -
                                                sessionData.room_created_ms,
                                            intl,
                                        )}
                                    </Text>
                                </Flex>
                                <Flex className={'compact-flex-container'}>
                                    <Text className="player-size-text">
                                        <FormattedMessage
                                            id="common.num_players"
                                            values={{
                                                number: sessionData.max_rmb_player_count || 0,
                                            }}
                                        />
                                    </Text>
                                </Flex>
                            </Flex>
                        ))}
                </VStack>
            )}
        </>
    );
};
